type ResizeOptions = {
  width?: number
  height?: number
  fit?: string
}

const resizeImgix = (url: URL, { width, height, fit }: ResizeOptions): string => {
  url.searchParams.set("auto", "format")
  if (width) url.searchParams.set("width", width.toString())
  if (height) url.searchParams.set("height", height.toString())
  if (fit) url.searchParams.set("fit", fit)
  return url.toString()
}

const resizeCloudflare = (url: URL, { width, height, fit }: ResizeOptions): string => {
  const params = ["format=auto"]
  if (width) params.push(`w=${width}`)
  if (height) params.push(`h=${height}`)
  if (fit) params.push(`fit=${fit}`)
  const path = url.pathname.replace(/^\/cdn-cgi\/image\/[^/]*\//, "/")
  return `${url.origin}/cdn-cgi/image/${params.join(",")}${path}${url.search}`
}

const imageResize = (originUrl: string, options: ResizeOptions): string => {
  if (!originUrl) return originUrl
  try {
    const url = new URL(originUrl)
    if (url.hostname.includes("imgix.net")) return resizeImgix(url, options)
    if (url.hostname.includes("chatbcc.com")) return resizeCloudflare(url, options)
  } catch (e) {
    console.warn("[image-resize] failed to parse URL", originUrl, e)
  }
  return originUrl
}

export default imageResize
